import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { DashboardVendedorFilters } from "../../../../types/filter";
import { useGetDashboardVendedoresFiltersQuery } from "../../../../api/filter/dataFilterApi";

interface Props {
    filters: DashboardVendedorFilters;
    setFilters: Dispatch<SetStateAction<DashboardVendedorFilters>>
}

export function Filters({ filters, setFilters }: Props) {

    const { data: filterValues } = useGetDashboardVendedoresFiltersQuery();

    const onFilterChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFilters({
            ...filters,
            [event.target.name]: event.target.value
        });
    }

    return (
        <div className="w-full p-2 border-2 border-slate-200 rounded-lg shadow-sm py-4 my-4">
            <div className="grid grid-cols-4 w-full gap-y-3 sm:gap-y-2 gap-x-3 text-left">

                <div className="col-span-2 flex flex-col sm:flex-row">
                    <label
                        className="font-semibold text-gray-800 w-full sm:w-1/3 text-center"
                        htmlFor="fechaInicio">
                        Fecha inicial:
                    </label>
                    <input 
                        className="input w-11/12 sm:w-2/3"
                        id="fechaInicio"
                        type="date"
                        name="fechaInicial"
                        onChange={onFilterChange}
                        value={filters.fechaInicial}
                        color="primary"/>
                </div>

                <div className="col-span-2 flex flex-col sm:flex-row">
                    <label
                        className="font-semibold text-gray-800 w-full sm:w-1/3 text-center"
                        htmlFor="fechaFinal">
                        Fecha final:
                    </label>
                    <input 
                        className="input w-11/12 sm:w-2/3"
                        id="fechaFinal"
                        type="date"
                        name="fechaFinal"
                        onChange={onFilterChange}
                        value={filters.fechaFinal}
                        color="primary"/>
                </div>


                <div className="col-span-2 flex flex-col sm:flex-row">
                    <label
                        className="font-semibold text-gray-800 w-full sm:w-1/3 text-center"
                        htmlFor="estatus">
                        Estatus de empresa:
                    </label>
                    <select
                        onChange={onFilterChange}
                        value={filters.estatus}
                        name="estatus"
                        id="estatus"
                        className={`input`} >
                        <option value={""} hidden>Seleccionar estatus</option>
                        <option value={""}>Todos los estatus</option>
                        {filterValues?.estatus.map((estatus, index) => (
                        <option key={index} value={estatus}>{estatus}</option>
                        ))}
                    </select>
                </div>

                <div className="col-span-2 flex flex-col sm:flex-row">
                    <label
                        className="font-semibold text-gray-800 w-full sm:w-1/3 text-center"
                        htmlFor="vendedores">
                        Vendedor:
                    </label>
                    <select
                        onChange={onFilterChange}
                        value={filters.vendedores}
                        name="vendedores"
                        id="vendedores"
                        className={`input`} >
                        <option value={""} hidden>Seleccionar vendedor</option>
                        <option value={""}>Todos los vendedores</option>
                        {filterValues?.vendedores.map((vendedor, index) => (
                        <option key={index} value={vendedor.id}>{vendedor.nombre}</option>
                        ))}
                    </select>
                </div>


                <div className="col-span-2 flex flex-col sm:flex-row">
                    <label
                        className="font-semibold text-gray-800 w-full sm:w-1/3 text-center"
                        htmlFor="">
                        Tipo de vendedor:
                    </label>
                    <select
                        onChange={onFilterChange}
                        value={filters.tipoVendedor}
                        name="tipoVendedor"
                        id="tipoVendedor"
                        className={`input`} >
                        <option value={""} hidden>Seleccionar tipo de vendedor</option>
                        <option value={""}>Todos los tipos</option>
                        {filterValues?.tipoVendedores.map((tipo, index) => (
                        <option key={index} value={tipo}>{tipo}</option>
                        ))}
                    </select>
                </div>

            </div>
        </div>
    );
}
